import React from 'react'
import forOwn from 'mout/object/forOwn'
import { parse } from 'url';

/*<!-- score score-blocks total height is 300px, so use percentages based on 300px. -->*/
export default function CompositeThreshold ({threshold, thresholdBreaks}) {

  let total = 0

  function computeBars(thresholdComposite, thresholdBreaks) {
    let bars = {}
    thresholdBreaks.forEach(function tallyThresholds(breakpoint, n) {
      forOwn(thresholdComposite, (val, key) => {
        if (n === 0) {
          if (parseInt(key, 10) <= breakpoint) {
            total += parseInt(val, 10)
            if (bars[breakpoint]) {
              bars[breakpoint] += parseInt(val, 10)
            } else {
              bars[breakpoint] = parseInt(val, 10)
            } 
          }
        } else if (n === thresholdBreaks.length - 1) {
          if (parseInt(key, 10) >= breakpoint) {
            total += parseInt(val, 10)
            if (bars[breakpoint]) {
              bars[breakpoint] += parseInt(val, 10)
            } else {
              bars[breakpoint] = parseInt(val, 10)
            }
          }
        } else {
          if (parseInt(key, 10) === parseInt(breakpoint, 10)) {
            total += parseInt(val, 10)
            if (bars[breakpoint]) {
              bars[breakpoint] += parseInt(val, 10)
            } else {
              bars[breakpoint = parseInt(val, 10)]
            }
          }
        }
      })
    })
    return bars
  }

  const bars = computeBars(threshold.composite, thresholdBreaks)
  let b = []
  thresholdBreaks.forEach((key) => {
    let perc
    if (total && bars[key]) {
      perc = bars[key] / total
    } else {
      perc = 0
    }
   
    b.push({
      height: `${Math.round(perc * 300)}px`,
      percent: `${Math.round(perc * 100)}%`,
    })
  })

  return (
    <div className="composite-scores">
      <h4>Composite Scores</h4>
      <h5>By Threshold</h5>
      
      <div className="composite-scores-chart">

      <div className="barGraphs">
        <div className="score scored-15-or-below" style={{left: '7px'}}>
          <div 
            className="score-block scored-15-or-below" 
            style={{
              height: b[0].height
            }}>
            <span className="score-number">{b[0].percent}</span>
          </div>
        </div>

        <div className="score scored-16" style={{left: '75px'}}>
          <div className="score-block scored-16" style={{height: b[1].height}}>
            <span className="score-number">{b[1].percent}</span>
          </div>
        </div>


        <div className="score scored-17" style={{left: '145px'}}>
          <div className="score-block scored-17" style={{height: b[2].height}}>
            <span className="score-number">{b[2].percent}</span>
          </div>
        </div>


        <div className="score scored-18-or-above" style={{left: '215px'}}>
          <div className="score-block scored-18-or-above" style={{height: b[3].height}}>
            <span className="score-number">{b[3].percent}</span>
          </div>
        </div>
      </div>

      <div id="verticalBar">
        <ul>
          <li>100%</li>
          <li>90%</li>
          <li>80%</li>
          <li>70%</li>
          <li>60%</li>
          <li>50%</li>
          <li>40%</li>
          <li>30%</li>
          <li>20%</li>
          <li>10%</li>
          <li>0%</li>
        </ul>
      </div>


      <div id="horizontalBar">
        <ul>
          <li>Scored 15</li>
          <li>Scored 16</li>
          <li>Scored 17</li>
          <li style={{marginRight: '0px'}}>Scored 18+</li>
        </ul>
      </div>
      </div>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/Threshold/CompositeThreshold.js